export const TEMPLATE_URL = {
  DISEASE: '/templates/diseases.xls'
};
